<template>
  <div class="form-group">
    <label :class="tituloClass">{{ $t(titulo) }}</label>
    <!-- @slot Conteudo desde block -->
    <slot></slot>
  </div>
</template>
<script>
/**
 * Um bloco de informação com titulo para renderizar dentro de um form
 */
export default {
  name: "FormInput",
  props: {
    /**
     * Título desde block
     */
    titulo: {
      type: String
    },
     /**
     * Class que serao adicionadas ao titulo
     */
    tituloClass: {
      type: String
    }
  }
};
</script>
